import { useDispatch, useSelector } from "react-redux"
import { getIsLoggedIn } from "../../../reducers/application"
import React from "react"
import actionTypes from "actions/actionTypes"
import { CarrotErrorCodes } from "../../../utils/CarrotErrors"
import { useQueryParam } from "use-query-params"

type AuthenticationContextProps = {
  isLoggedIn: boolean
  handleSessionExpiration: () => void
}

const AuthenticationContext = React.createContext<AuthenticationContextProps>(null)

export const useAuthentication = () => React.useContext(AuthenticationContext)

export function AuthenticationProvider({ children }) {
  const [_, setErrorCode] = useQueryParam("errorCode")
  const isLoggedIn = useSelector(getIsLoggedIn)
  const dispatch = useDispatch()

  function handleSessionExpiration() {
    dispatch({
      type: actionTypes.SESSION_EXPIRED
    })
    setErrorCode(CarrotErrorCodes.NOT_AUTHENTICATED)
  }

  return (
    <AuthenticationContext.Provider value={{ isLoggedIn, handleSessionExpiration }}>
      {children}
    </AuthenticationContext.Provider>
  )
}
